import React, { memo } from 'react';
import { Primary, type PrimaryProps } from './Variants/Primary/Primary';
import { SmallOne, type SmallOneProps } from './Variants/SmallOne/SmallOne';
import { Hallow, type HallowProps } from './Variants/Hallow/Hallow';

export const PinionManVariants = {
  PRIMARY: 'Primary',
  SMALL_ONE: 'SmallOne',
  HALLOW: 'Hallow',
} as const;

type PinionManIconProps =
  | ({ variant: typeof PinionManVariants.PRIMARY } & PrimaryProps)
  | ({ variant: typeof PinionManVariants.SMALL_ONE } & SmallOneProps)
  | ({ variant: typeof PinionManVariants.HALLOW } & HallowProps);

export const PinionManIcon: React.FC<PinionManIconProps> = memo((props) => {
  switch (props.variant) {
    case PinionManVariants.PRIMARY:
      return <Primary {...props} />;
    case PinionManVariants.SMALL_ONE:
      return <SmallOne {...props} />;
    case PinionManVariants.HALLOW:
      return <Hallow {...props} />;
  }
});

PinionManIcon.displayName = 'PinionManIcon';
